import { Pipe, PipeTransform } from '@angular/core';
import pluralize from 'pluralize';

@Pipe({ name: 'caPluralize', standalone: true })
export class PluralizePipe implements PipeTransform {
  transform(key: string, count: number): string {
    return pluralize(key, count);
  }
}
